import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Warning } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { DappGatewayButton } from '../components/Header/DappGatewayButton';
import { useUserState } from '../contexts/UserContext';

export const SyncWalletsPage = () => {
  const { loggedInUser } = useUserState();
  const nav = useNavigate();
  useEffect(() => {
    if (!loggedInUser) {
      nav('/login');
    }
  }, [loggedInUser, nav]);
  return (
    <Box sx={{ maxWidth: '300px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ mb: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Warning color="warning" />
        <Typography variant="body2">No primary party set</Typography>
      </Box>
      <Typography>
        You have connected via dApp gateway, but you do not have a primary party set. Set your
        primary party via the dapp gateway popup. (It should be open, but if closed you can click on
        the Gateway button below).
      </Typography>
      <Box sx={{ mt: 1 }}>
        <DappGatewayButton />
      </Box>
    </Box>
  );
};
